"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getCountryBounds = exports.supportedTwoLetterCodes = exports.twoLetterCodesToThree = void 0;
const allCountryBounds_json_1 = __importDefault(require("./allCountryBounds.json"));
exports.twoLetterCodesToThree = {
    au: "AUS",
    br: "BRA",
    ca: "CAN",
    us: "USA",
};
exports.supportedTwoLetterCodes = ["us", "ca", "br", "au"];
/**
 * Get geographic boundary for a country. Uses standard three-letter abbreviations
 * (`BRA`, `USA`, etc.), but to make it easy to pipe `@fabric/core`'s `getCountryFromUrl`
 * in, also takes the following two-letter codes:
 *
 * - au
 * - br
 * - ca
 * - us
 *
 * @returns a FitBounds object to allow for the viewing of a country within the map's viewport.
 *
 * Note: This FitBounds object returned isn't the country's official borders.
 * So don't use this function to to determine if a location is officially within a country or not.
 */
const getCountryBounds = (country) => {
    const countryCode = exports.supportedTwoLetterCodes.some((code) => code === country)
        ? exports.twoLetterCodesToThree[country]
        : country;
    const { ne, sw } = allCountryBounds_json_1.default[countryCode];
    return [
        [ne.lon, ne.lat],
        [sw.lon, sw.lat],
    ];
};
exports.getCountryBounds = getCountryBounds;
